import { router, useGlobalSearchParams } from "expo-router";
import { View } from "tamagui";

import { api } from "~/utils/api";
import type {
  ResearchFunnelSchemaType,
  Slices,
} from "~/components/feature/research";
import { CreateResearchFunnel } from "~/components/feature/research";

const Create = () => {
  const { type } = useGlobalSearchParams<{
    type: Slices;
  }>();

  const { mutateAsync } = api.research.create.useMutation();
  const { mutateAsync: syncParticipantsAsync } =
    api.research.syncParticipants.useMutation({
      onSuccess: () => router.push(`/research/${type}`),
    });

  const onSubmit = async (data: ResearchFunnelSchemaType) => {
    const create = await mutateAsync({ name: data.name, type });
    await syncParticipantsAsync({
      researchId: create.id ?? "",
      ids: data.users.map((u) => u.id),
    });
  };

  return (
    <CreateResearchFunnel.Provider>
      <View gap={"$4"}>
        <CreateResearchFunnel.Progress />
        <CreateResearchFunnel.Header />
        <CreateResearchFunnel.Form onSubmit={onSubmit}>
          <CreateResearchFunnel.CurrentFormField />
          <CreateResearchFunnel.Controls />
        </CreateResearchFunnel.Form>
      </View>
    </CreateResearchFunnel.Provider>
  );
};

export default Create;
